import { Box, Heading, Grid, useDisclosure } from "@chakra-ui/react";
import DescriptionCardUserGuide from "./DescriptionCardUserGuide";
import PDFPreviewModal from './PDFPreviewModal';
import UseRJupyter from './images/UserGuideImages/UseR_Jupyter.png';
import UploadDatasetIMG from './images/UserGuideImages/UploadDatasetIMG.png';
import UsePyJupyter from './images/UserGuideImages/PythonOnJupyterHub.png';
import ConnectDBRJupyter from './images/UserGuideImages/ConnectDBUsingR.png';
import ComingSoon from './images/UserGuideImages/ComingSoon.png';
import CMapApacheSuperset from './images/UserGuideImages/CountryMapApacheSuperset.png';
import SurveyGuide from './images/UserGuideImages/SurveyGuide.png';
import UploadUserGuide from './images/UserGuideImages/UploadUserGuide.jpg';
import VideoGuide from './images/UserGuideImages/VideoGuide.png';

import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useNavigate } from "react-router-dom";


const downloadPDF = (filePath, fileName) => {
    const link = document.createElement("a");
    link.href = filePath;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export default function UserGuidePage() {

    const navigate = useNavigate();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { t } = useTranslation();
    const [currentPDF, setCurrentPDF] = useState(null);


    // const [buttonStates, setButtonStates] = useState({
    //     6: { isDownloadDisabled: true, isPreviewDisabled: true },
    //     7: { isDownloadDisabled: true, isPreviewDisabled: true },
    //     8: { isDownloadDisabled: true, isPreviewDisabled: true }
    // });

    const pdfFiles = [
        {
            id: 0,
            variant: "pdf",
            filePath: "/UserGuides/How_To_Upload_Datasets_In_AMELIADP_V1.0.pdf",
            fileName: "How_To_Upload_Datasets_In_AMELIADP_V1.0.pdf",
            title: t('infoPage.manualTitle_Index0'),
            description: t('infoPage.manualDescription_Index0'),
            description2: t('infoPage.clickDownloadPDF'),
            textButton: t('infoPage.buttonDownloadPDFGuide'),
            textButton2: t('infoPage.guidePreview'),
            imgUrl: UploadDatasetIMG,
        },
        {
            id: 1,
            variant: "pdf",
            filePath: "/UserGuides/Connecting_To_A_DB_Using_R_JupyterHub_V3.2.pdf",
            fileName: "Connecting_To_A_DB_Using_R_JupyterHub_V3.2.pdf",
            title: t('infoPage.manualTitle_Index1'),
            description: t('infoPage.manualDescription_Index1'),
            description2: t('infoPage.clickDownloadPDF'),
            textButton: t('infoPage.buttonDownloadPDFGuide'),
            textButton2: t('infoPage.guidePreview'),
            imgUrl: ConnectDBRJupyter,
        },
        {
            id: 2,
            variant: "pdf",
            filePath: "/UserGuides/Connecting_To_A_DB_Using_Python_JupyterHub_V3.0.pdf",
            fileName: "Connecting_To_A_DB_Using_Python_JupyterHub_V3.0.pdf",
            title: t('infoPage.manualTitle_Index2'),
            description: t('infoPage.manualDescription_Index2'),
            description2: t('infoPage.clickDownloadPDF'),
            textButton: t('infoPage.buttonDownloadPDFGuide'),
            textButton2: t('infoPage.guidePreview'),
            imgUrl: UsePyJupyter,
        },
        {
            id: 3,
            variant: "pdf",
            filePath: "/UserGuides/Country_Maps_in_Apache_Superset_V1.0.pdf",
            fileName: "Country_Maps_in_Apache_Superset_V1.0.pdf",
            title: t('infoPage.manualTitle_Index4'),
            // description: t('infoPage.manualDescription_Index1'),
            description: t("infoPage.manualDescription_Index4"),
            description2: t('infoPage.clickDownloadPDF'),
            textButton: t('infoPage.buttonDownloadPDFGuide'),
            textButton2: t('infoPage.guidePreview'),
            imgUrl: CMapApacheSuperset,
        },
        {
            id: 4,
            variant: "pdf",
            filePath: "/UserGuides/How_To_Use_SurveyTool_AMELIA_V3.3.pdf",
            fileName: "How_To_Use_SurveyTool_AMELIA_V3.3.pdf",
            title: t('infoPage.surveyGuide'),
            description: t('infoPage.manualDescription_Index5'),
            description2: t('infoPage.clickDownloadPDF'),
            textButton: t('infoPage.buttonDownloadPDFGuide'),
            textButton2: t('infoPage.guidePreview'),
            imgUrl: SurveyGuide,
        },
        {
            id: 5,
            variant: "pdf",
            filePath: "/UserGuides/File_Upload_Requirements_V3.1.0.pdf",
            fileName: "File_Upload_Requirements_V3.1.0.pdf",
            title: t('infoPage.manualTitle_Index6'),
            // description: t('infoPage.manualDescription_Index1'),
            description: t('infoPage.manualDescription_Index6'),
            description2: t('infoPage.clickDownloadPDF'),
            textButton: t('infoPage.buttonDownloadPDFGuide'),
            textButton2: t('infoPage.guidePreview'),
            imgUrl: UploadUserGuide,
        },
        // { //PREDISP. VIDEO GUIDE PORTAL
        //     id: 6,
        //     variant: "video-portal",
        //     filePath: "/UserGuides/How_To_Use_R_In_AMELIADP_V1.0.pdf",
        //     fileName: "How_To_Use_R_In_AMELIADP_V1.0.pdf",
        //     title: "Video Guides Portal",
        //     description: "",
        //     description2: t('infoPage.clickDownloadPDF'),
        //     textButton: t('infoPage.buttonDownloadPDFGuide'),
        //     textButton2: t('infoPage.guidePreview'),
        //     imgUrl: VideoGuide,
        // },
        {
            id: 6,
            variant: "pdf",
            filePath: "/UserGuides/How_To_Use_R_In_AMELIADP_V1.0.pdf",
            fileName: "How_To_Use_R_In_AMELIADP_V1.0.pdf",
            title: t('infoPage.comingSoon'),
            description: "",
            description2: t('infoPage.clickDownloadPDF'),
            textButton: t('infoPage.buttonDownloadPDFGuide'),
            textButton2: t('infoPage.guidePreview'),
            imgUrl: ComingSoon,
            isDownloadDisabled: true,
            isPreviewDisabled: true
        },
        {
            id: 7,
            filePath: "/UserGuides/How_To_Use_R_In_AMELIADP_V1.0.pdf",
            fileName: "How_To_Use_R_In_AMELIADP_V1.0.pdf",
            title: t('infoPage.comingSoon'),
            // description: t('infoPage.manualDescription_Index1'),
            description: "",
            description2: t('infoPage.clickDownloadPDF'),
            textButton: t('infoPage.buttonDownloadPDFGuide'),
            textButton2: t('infoPage.guidePreview'),
            imgUrl: ComingSoon,
        },
        {
            id: 8,
            filePath: "/UserGuides/How_To_Use_R_In_AMELIADP_V1.0.pdf",
            fileName: "How_To_Use_R_In_AMELIADP_V1.0.pdf",
            title: t('infoPage.comingSoon'),
            // description: t('infoPage.manualDescription_Index1'),
            description: "",
            description2: t('infoPage.clickDownloadPDF'),
            textButton: t('infoPage.buttonDownloadPDFGuide'),
            textButton2: t('infoPage.guidePreview'),
            imgUrl: ComingSoon,
        },
    ];

    const handleGuidePreview = (file) => {
        setCurrentPDF(file);
        onOpen();
    };

    return (
        <Box h="100%" w="100%" bgColor="#f6f3ec" overflowY="auto">
            <Box h="8%" w="100%" paddingLeft="10px" mb={2}>
                <Heading
                    fontFamily="inherit"
                    fontWeight="bold"
                    color={"rgba(11,78,90,255)"}
                >
                    AMELIA - {t('infoPage.userGuide')}
                </Heading>
            </Box>

            <Box px={6} py={2}>
                <Grid
                    templateColumns="repeat(3, minmax(0, 430px))"
                    gap={6}
                    justifyContent="center"
                    mx="auto"
                    maxW="1350px"
                >
                    {pdfFiles.map((file) => {
                        const isPDF = file.variant === "pdf";
                        const isVideoPortal = file.variant === "video-portal";

                        return (
                            <DescriptionCardUserGuide
                                key={file.id}
                                title={file.title}
                                description={file.description}
                                description2={file.description2}
                                textButton={file.textButton}
                                textButton2={file.textButton2}
                                ImgUrl={file.imgUrl}
                                variant={file.variant}
                                onClick={
                                    isPDF
                                        ? () => downloadPDF(file.filePath, file.fileName)
                                        : isVideoPortal
                                            ? () => navigate("/video-guides")
                                            : undefined
                                }
                                onPreview={isPDF ? () => handleGuidePreview(file) : undefined}
                                isDownloadDisabled={file.isDownloadDisabled ?? !isPDF}
                                isPreviewDisabled={file.isPreviewDisabled ?? !isPDF}
                            />
                        );
                    })}
                </Grid>
            </Box>

            {currentPDF && (
                <PDFPreviewModal
                    isOpen={isOpen}
                    onClose={onClose}
                    pdfFilePath={currentPDF.filePath}
                    title={currentPDF.title}
                />
            )}
        </Box>
    );
}     